import { Config } from "../config/Config";
import { io } from "socket.io-client";
import { getFromStorage, isAuthenticated } from "./Helper";
const userData  = getFromStorage({ key: 'user_data'});



const SOCKETURL = Config?.REACT_APP_SOCKET_BASE_URL;
export const socket = io(`${SOCKETURL}${userData?.data.id}`, { transports: ['websocket', 'polling', "webtransport"], auth: { token: isAuthenticated() } });



export const DisconnectEvent = () => {
    socket.disconnect();
}

export const socketEmit = async (dispatch: any, socket_url: string, Redux_type: string, payload: any = {}) => {
    socket.emit(socket_url, payload, async (Response: any) => {
        dispatch({
            type: `${Redux_type}_SUCCESS`,
            payload: Response
        })
    })
}
